import React, { useContext, useEffect, useState } from "react";
import "../Assets/css/brand.css";
import InfluencerCardList from "../Common/InfluencerCardList";
import Search from "../Assets/Img/search.png";
import Heart from "../Assets/Img/Heart.png";
import HeartDark from "../Assets/Img/HeartDark.png";
import Filter from "../Assets/Img/Filter.png";
import Sort from "../Assets/Img/sort.png";
import SortDown from "../Assets/Img/sort.png"; // Add a descending icon if needed
import View from "../Assets/Img/View.png";
import tableicon from "../Assets/Img/tableicon.png";
import InfluencerGridList from "../Common/InfluencerGridList";
import axiosMain from "./../http/axiosMain";
import users from "../Assets/Img/users.png";
import ProfileImg from "../Assets/Img/Imgs.png";
import { useNavigate } from "react-router-dom";
import { Modal, Form, Dropdown } from "react-bootstrap";
import instagram from "../Assets/Img/Instagram.svg";
import youtube from "../Assets/Img/YouTube.svg";
import facebook from "../Assets/Img/facebook.png";
import LinkedIn from "../Assets/Img/LinkedIn.png";
import { FaEdit } from "react-icons/fa"; // Import Edit Icon
import { FaPlus } from "react-icons/fa";
import { GlobalContext } from "../../utils/GlobalContext";
import { toast, ToastContainer, } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';  // Don't forget this import for styles

// kanj
const CURRENT_USER_ROLE = localStorage.getItem("role");
console.log("kanj--------------", CURRENT_USER_ROLE);
// kanj

// const initialData = [
//   {
//     id: 1,
//     name: "John Morgan",
//     category: "Photography",
//     engagement: "4%",
//     audience: "120k",
//     genderStats: { male: "63%", female: "30%", others: "7%" },
//     image: "https://via.placeholder.com/50",
//   },
//   {
//     id: 2,
//     name: "Alice Smith",
//     category: "Fashion",
//     engagement: "5%",
//     audience: "90k",
//     genderStats: { male: "40%", female: "50%", others: "10%" },
//     image: "https://via.placeholder.com/50",
//   },
//   {
//     id: 3,
//     name: "Tom Brown",
//     category: "Travel",
//     engagement: "3%",
//     audience: "110k",
//     genderStats: { male: "70%", female: "20%", others: "10%" },
//     image: "https://via.placeholder.com/50",
//   },
//   {
//     id: 4,
//     name: "Emma Wilson",
//     category: "Lifestyle",
//     engagement: "6%",
//     audience: "150k",
//     genderStats: { male: "50%", female: "45%", others: "5%" },
//     image: "https://via.placeholder.com/50",
//   },
//   {
//     id: 5,
//     name: "Liam Johnson",
//     category: "Gaming",
//     engagement: "7%",
//     audience: "80k",
//     genderStats: { male: "80%", female: "15%", others: "5%" },
//     image: "https://via.placeholder.com/50",
//   },
// ];
const environment = process.env.REACT_APP_ENVIRONMENT;

function BrandHome({ show }) {
  const { isLogdin, setisLogdin } = useContext(GlobalContext);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [showEditOptions, setShowEditOptions] = useState(false);
  const [influencers, setInfluencers] = useState([]);
  const [originalInfluencers, setOriginalInfluencers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userData, setUserData } = useContext(GlobalContext);
  const [userEmail, setUserEmail] = useState("");
  const [isrefreshModalOpen, setIsModalOpen] = useState(!localStorage.getItem("brand_name")); // Prevent opening if brand_name exists


  const [searchTerm, setSearchTerm] = useState("");

  const [filteredData, setFilteredData] = useState();
  const [selectedFilters, setSelectedFilters] = useState({});
  const [otp, setOtp] = useState(true); // Assume OTP is true initially
  const [step1, setStep1] = useState(true);

  const [isFavoritesFiltered, setIsFavoritesFiltered] = useState(false);
  const [profileDetails, setProfileDetails] = useState({
    logo: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    pin: "",
    city: "",
  });
  const [profileSetupDetails, setProfileSetupDetails] = useState({
    bio: "",
    website: "",
    socialLinks: [{ platform: "Instagram", url: "" }],
  });

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  // const [ModalOpen, setIsModalOpen] = useState(false); // store brand nameeee

  // const categories = ["Fashion", "Tech", "Food", "Beauty", "Fitness"];
  const [categories, setCategories] = useState([]); // Initialize categories as an empty array
  console.log("brand home");
  
  console.log(environment,"environment");
// for clear modal
const resetAllFields = () => {
  setProfileDetails({
    logo: null,
    logoPreview: null,
    name: "",
    phone: "",
    email: "",
    address: "",
    pin: "",
  });

  setProfileSetupDetails({
    website: "",
    socialLinks: [{ platform: "", link: "" }],
    bio: "",
  });

  setSelectedCategories([]);
  setSelectedStates([]);
  setSelectedCity("");
};



  // store brand nameeee
  useEffect(() => {
    // Check if brand_name is stored in localStorage
    if (!localStorage.getItem("brand_name")) {
      setIsModalOpen(true);
    }
  }, []);

  const states = [
    "Maharashtra",
    "Karnataka",
    "Tamil Nadu",
    "Uttar Pradesh",
    "Rajasthan",
  ];
  const cities = ["Mumbai", "Bengaluru", "Chennai", "Delhi", "Kolkata"];

  useEffect(() => {
    if (otp) {
      setShowEditProfileModal(true);
    }
  }, [otp]);

  /**Use this useeffect for show signup user email in modal */
  useEffect(() => {
    const email = sessionStorage.getItem("email"); // Retrieve email from session
    const phone = sessionStorage.getItem("phone"); // Retrieve email from session
    if (email) {
      setUserEmail(email);
      setProfileDetails((prevDetails) => ({
        ...prevDetails,
        email: email, // Update profileDetails with stored email
      }));
    }
  }, [setProfileDetails]);

  const handleCloseEditProfileModal = () => {
    setShowEditProfileModal(false);
  };
  const handleCheckboxChange = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosMain.get("/api/v1/get-categories");
        if (response.data && response.data.categories) {
          setCategories(response.data.categories); // Store API response
        } else {
          console.error("Invalid category format received:", response.data);
          setCategories([]); // Fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]); // Fallback to empty array
      }
    };

    fetchCategories();
  }, []);

  const handleNext = () => {
    setStep1(!step1);
  };

  const navigate = useNavigate();
  
  useEffect(()=>{
    const role = localStorage.getItem("userType");
      if(role === "influencer"){
        navigate('/influencer-home')
      }else if(role!=="brand"){
        navigate('/login')

      }
     
    },[])


  // const toggleFavorite = (id) => {
  //   const url = "/api/v1/liked-influencer";
  //   const payload = { influencer_id: id };

  //   axiosMain
  //     .post(url, payload)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         console.log("API Response:", response.data);

  //         setFavorites((prevFavorites) => {
  //           const updatedFavorites = new Set(prevFavorites);
  //           if (updatedFavorites.has(id)) {
  //             updatedFavorites.delete(id);
  //           } else {
  //             updatedFavorites.add(id);
  //           }

  //           // Save updated favorites to local storage
  //           localStorage.setItem(
  //             "favoriteInfluencers",
  //             JSON.stringify([...updatedFavorites])
  //           );

  //           return updatedFavorites;
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //     });
  // };

  // // Retrieve favorites from local storage on component mount
  // useEffect(() => {
  //   const storedFavorites = JSON.parse(
  //     localStorage.getItem("favoriteInfluencers")
  //   );
  //   if (storedFavorites) {
  //     setFavorites(new Set(storedFavorites));
  //   }
  // }, []);
  const [favorites, setFavorites] = useState(new Set(JSON.parse(localStorage.getItem("favoriteInfluencers")) || []));

  const toggleFavorite = (id) => {
    const influencer = influencers.find((inf) => inf.influencer_id === id);
    if (!influencer) return;

    const isFavorite = favorites.has(id);
    const newFavorites = new Set(favorites);

    // **Show toast message immediately with react-toastify**
    const toastMessage = isFavorite
      ? `${influencer.influencer_name} removed from favourites!`
      : `${influencer.influencer_name} added to favourites!`;

    // **Conditionally apply styles for green (added) or red (removed)**
    const toastStyle = isFavorite ? "toast-error" : "toast-success"; // Use 'toast-error' for removal (red) and 'toast-success' for adding (green)

    toast(toastMessage, {
      position: "top-right",
      autoClose: 1000,  // 3 seconds auto-close
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      className: toastStyle, // Apply the custom class for styling
    });

    // **Update favorites list**
    if (isFavorite) {
      newFavorites.delete(id);
    } else {
      newFavorites.add(id);
    }

    setFavorites(newFavorites);
    localStorage.setItem("favoriteInfluencers", JSON.stringify([...newFavorites]));

    // API call to update favorites in the backend
    axiosMain
      .post("/api/v1/liked-influencer", { influencer_id: id })
      .then((response) => {
        if (response.status === 200) {
          console.log(`API Updated: ${influencer.influencer_name}`);
        }
      })
      .catch((error) => {
        console.error("Error updating favorite:", error);
      });
  };

  // Retrieve favorites from local storage on component mount
  useEffect(() => {
    const storedFavorites = JSON.parse(localStorage.getItem("favoriteInfluencers"));
    if (storedFavorites) {
      setFavorites(new Set(storedFavorites));
    }
  }, []);

  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [totalInfluencers, setTotalInfluencers] = useState(0);
  const [selectedTab, setSelectedTab] = useState("home");
  // const [favorites, setFavorites] = useState(new Set());
  const [sortParams, setSortParams] = useState({
    isEngagementSortedAsc: false,
    isEngagementSortedDesc: false,
    isFollowersSortedAsc: false,
    isFollowersSortedDesc: false,
  });
  const handleSortClick = (field) => {
    setSortParams((prevState) => {
      const currentAsc = prevState[`is${field}SortedAsc`];
      const currentDesc = prevState[`is${field}SortedDesc`];

      return {
        isEngagementSortedAsc:
          field === "Engagement" ? !currentAsc && !currentDesc : false,
        isEngagementSortedDesc: field === "Engagement" ? currentAsc : false,
        isFollowersSortedAsc:
          field === "Followers" ? !currentAsc && !currentDesc : false,
        isFollowersSortedDesc: field === "Followers" ? currentAsc : false,
      };
    });
  };

  const [selectedEngagementFilters, setSelectedEngagementFilters] = useState(
    new Set()
  );
  const [sortDirectionEngagement, setSortDirectionEngagement] = useState("asc");
  const [sortDirectionFollowers, setSortDirectionFollowers] = useState("asc");
  const handleTabChange = (tabId) => {
    setSelectedTab(tabId);
  };

  const handleSearch = async (e) => {
    setSearchTerm(e.target.value);
  };
  const toggleFilterPopup = () => {
    setIsFilterPopupOpen(!isFilterPopupOpen);
    if (!isFilterPopupOpen) {
      setTotalInfluencers(influencers?.length); // Show full count when filter opens
    }
  };

  const handleClearFilters = () => {
    setSelectedEngagementFilters(new Set());
    setFilteredData(influencers); // Reset data
    setTotalInfluencers(influencers?.length); // Reset count
  };

  const [isLikedFilter, setIsLikedFilter] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (!searchTerm) {
        fetchInfluencers();
        return;
      }

      setLoading(true);

      try {
        const response = await axiosMain.get(
          `/api/v1/search-influencer?search=${searchTerm}`
        );
        setInfluencers(response.data.influencers); // Assuming the response contains the data directly
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    // Debounce to avoid making too many requests on every keystroke
    const timer = setTimeout(() => fetchData(), 500);

    // Cleanup on searchTerm change
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleEngagementFilterChange = (range) => {
    setSelectedEngagementFilters((prevFilters) => {
      const newFilters = new Set(prevFilters);
      if (newFilters.has(range)) {
        newFilters.delete(range);
      } else {
        newFilters.add(range);
      }
      return newFilters;
    });
  };

  const [grideView, setgrideView] = useState(false);
  const toggleView = () => {
    setgrideView(!grideView);
  };
  const applyFilters = () => {
    if (Object.keys(selectedFilters)?.length === 0) {
      setInfluencers(originalInfluencers); // Reset to original list
      return;
    }

    let filtered = [...originalInfluencers];

    Object.keys(selectedFilters).forEach((category) => {
      const selectedValues = Array.from(selectedFilters[category]);

      if (selectedValues?.length === 0) return;

      if (category === "home") {
        filtered = filtered.filter((inf) =>
          selectedValues.some((range) => {
            const [min, max] = range.split("-").map(Number);
            return inf.engagement >= min && inf.engagement <= max;
          })
        );
      }

      if (category === "menu1") {
        filtered = filtered.filter((inf) =>
          selectedValues.some((range) => {
            const [min, max] = range
              .replace(/k/g, "000")
              .split(" - ")
              .map(Number);
            return inf.reach >= min && inf.reach <= max;
          })
        );
      }

      if (category === "menu2") {
        filtered = filtered.filter((inf) =>
          selectedValues.includes(inf.language)
        );
      }

      if (category === "menu3") {
        filtered = filtered.filter((inf) =>
          selectedValues.some((range) => {
            const [min, max] = range
              .replace(/k/g, "000")
              .replace(/M/g, "000000")
              .split("-")
              .map(Number);
            return inf.followers >= min && inf.followers <= max;
          })
        );
      }

      if (category === "menu6") {
        filtered = filtered.filter((inf) => selectedValues.includes(inf.city));
      }
    });

    setInfluencers(filtered);
  };

  const handleSortEngagement = () => {
    setInfluencers((prevData) => {
      // Make sure to clone the array to avoid mutating the original data
      const sortedData = [...prevData].sort((a, b) => {
        // Attempt to parse the engagement values as floats
        const engagementA = parseFloat(a.engagement);
        const engagementB = parseFloat(b.engagement);

        // Check if both are valid numbers
        if (isNaN(engagementA) && isNaN(engagementB)) {
          return 0; // Both are NaN, no change in their order
        }
        if (isNaN(engagementA)) {
          // If A is NaN, move it to the bottom or top based on the sort direction
          return sortDirectionEngagement === "asc" ? 1 : -1;
        }
        if (isNaN(engagementB)) {
          // If B is NaN, move it to the bottom or top based on the sort direction
          return sortDirectionEngagement === "asc" ? -1 : 1;
        }

        // If both are valid numbers, sort them numerically based on direction
        return sortDirectionEngagement === "asc"
          ? engagementA - engagementB
          : engagementB - engagementA;
      });

      return sortedData;
    });

    // Toggle sort direction after each sort
    setSortDirectionEngagement((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const handleSortFollowers = () => {
    setSortDirectionFollowers((prev) => {
      const newDirection = prev === "asc" ? "desc" : "asc";

      setInfluencers((prevData) => {
        const sortedData = [...prevData].sort((a, b) => {
          const followersA = parseFloat(a.followers);
          const followersB = parseFloat(b.followers);

          if (isNaN(followersA) && isNaN(followersB)) return 0;
          if (isNaN(followersA)) return newDirection === "asc" ? 1 : -1;
          if (isNaN(followersB)) return newDirection === "asc" ? -1 : 1;

          return newDirection === "asc"
            ? followersA - followersB
            : followersB - followersA;
        });

        return sortedData;
      });

      return newDirection;
    });
  };

  const fetchInfluencers = async () => {
    try {
      const response = await axiosMain.get("/api/v1/influencers");
      console.log("kanj1111----...",response);
      
      setOriginalInfluencers(response.data.influencers); // Keep the original list
      setInfluencers(response.data.influencers); // Set influencers to display
      setLoading(false);
    } catch (error) {
      console.error("Error fetching influencers:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInfluencers();
  }, []);

  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [show]);
  // Handle background blur when modal is open
  // Handle blur effect on body when modal opens/closes
  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-blur-overlay-active");
    } else {
      document.body.classList.remove("modal-blur-overlay-active");
    }

    return () => {
      document.body.classList.remove("modal-blur-overlay-active");
    };
  }, [show]);

  if (loading) {
    return <div>Loading...</div>;
  }
  const handleReachFilterChange = (range) => {
    console.log(`Selected Reach range: ${range}`);
    // Add logic to update the state for Reach filters
  };

  const formatFollowers = (followers) => {
    if (followers >= 1000000) {
      return (followers / 1000000).toFixed(1) + "M"; // Format as "10.5M"
    } else if (followers >= 1000) {
      return (followers / 1000).toFixed(1) + "k"; // Format as "16.3k"
    } else {
      return followers; // No conversion, just return the number
    }
  };
  const filterOptions = {
    home: {
      label: "Engagement",
      options: [
        { value: "2-4", label: "2% - 4%" },
        { value: "5-7", label: "5% - 7%" },
        { value: "8-10", label: "8% - 10%" },
      ],
    },
    menu1: {
      label: "Reach",
      options: [
        { value: "0 - 100k", label: "(0 - 100k)" },
        { value: "100k - 200k", label: "(100k - 200k)" },
        { value: "200k - 200k", label: "(200k - 300k)" },
        { value: "300k - 400k", label: "(300k - 400k)" },
        { value: "400k - 500k", label: "(400k - 500k)" },
        { value: "500k - 600k", label: "(500k - 600k)" },
        { value: "600k - 700k", label: "(600k - 700k)" },
        { value: "700k - 800k", label: "(700k - 800k)" },
        { value: "800k - 900k", label: "(800k - 900k)" },
        { value: "900k+", label: "900k+" },
      ],
    },
    menu2: {
      label: "Language",
      options: [
        { value: "english", label: "English" },
        { value: "Hindi", label: "Hindi" },
        { value: "Gujarati", label: "Gujarati" },
        { value: "Punjabi", label: "Punjabi" },
        { value: "Telugu", label: "Telugu" },
        { value: "Tamil", label: "Tamil" },
        { value: "Malayalam", label: "Malayalam" },
        { value: "Kannada", label: "Kannada" },
      ],
    },
    menu3: {
      label: "Followers",
      options: [
        { value: "10k-100k", label: "1k - 10k" },
        { value: "100k-300k", label: "100k-300k" },
        { value: "300k-500k", label: "300k-500k" },
        { value: "500k-700k", label: "500k-700k" },
        { value: "700k-900k", label: "700k-900k" },
        { value: "900k-1M", label: "900k-1M" },
        { value: "1M-3M", label: "1M-3M" },
        { value: "3M+", label: "3M+" },
      ],
    },
    menu4: {
      label: "Genre",
      options: [
        { value: "Art & Photography", label: "Art & Photography" },
        {
          value: "Business & Entrepreneurship",
          label: "Business & Entrepreneurship",
        },
        { value: "Entertainment", label: "Entertainment" },
        { value: "Education", label: "Education" },
        {
          value: "Fitness, Fashion & Beauty",
          label: "Fitness, Fashion & Beauty",
        },
        { value: "Lifestyle & Travel", label: "Lifestyle & Travel" },
        { value: "Tech & Gaming", label: "Tech & Gaming" },
        { value: "Others", label: "Others" },
      ],
    },
    menu5: {
      label: "Age",
      options: [
        { value: "13-17", label: "13-17" },
        { value: "18-24", label: "18-24" },
        { value: "25-34", label: "25-34" },
        { value: "35-44", label: "35-44" },
        { value: "45-54", label: "45-54" },
        { value: "55-64", label: "55-64" },
        { value: "65+", label: "65+" },
      ],
    },
    menu6: {
      label: "City",
      options: [
        { value: "Mumbai", label: "Mumbai" },
        { value: "Delhi", label: "Delhi" },
        { value: "Bangalore", label: "Bangalore" },
        { value: "Chennai", label: "Chennai" },
        { value: "Kolkata", label: "Kolkata" },
        { value: "Jaipur", label: "Jaipur" },
        { value: "Hyderabad", label: "Hyderabad" },
        { value: "Other Cities", label: "Other Cities" },
      ],
    },
  };
  const handleFilterChange = (category, value) => {
    setSelectedFilters((prevFilters) => {
      const newFilters = { ...prevFilters };

      if (!newFilters[category]) {
        newFilters[category] = new Set(); // Ensure category exists
      } else {
        newFilters[category] = new Set(newFilters[category]); // Clone the Set
      }

      if (newFilters[category].has(value)) {
        newFilters[category].delete(value);
        if (newFilters[category].size === 0) delete newFilters[category]; // Remove empty category
      } else {
        newFilters[category].add(value);
      }

      return { ...newFilters }; // Return new object for state update
    });
  };
  const resetFilters = () => {
    setSelectedFilters({}); // Clear all selected filters
    setSelectedTab(Object.keys(filterOptions)[0]); // Reset to first tab (optional)
    setInfluencers(originalInfluencers); // Restore full influencer list
  };

  const favoritesSort = () => {
    if (isFavoritesFiltered) {
      setInfluencers(originalInfluencers); // Restore original list when toggling off
    } else {
      const favoriteInfluencers = originalInfluencers.filter((influencer) =>
        favorites.has(influencer.influencer_id)
      );
      setInfluencers(favoriteInfluencers);
    }

    setIsFavoritesFiltered(!isFavoritesFiltered); // Toggle state
  };
  // const [showModal, setShowModal] = useState(false);

  const isModalOpen = localStorage.getItem("openModal") === "true";

  const handleSave = async () => {
    const requestBody = {
      brand_name: profileDetails.name || "",
      categories: selectedCategories.join(", ") || "",
      bio: profileSetupDetails.bio || "",
      brand_website: profileSetupDetails.website || "",
      // social_links: JSON.stringify(profileSetupDetails.socialLinks) || "",
      city: selectedCity || "",
      address: profileDetails.address || "",
      state: selectedStates[0] || "",
      pincode: profileDetails.pin || "",
      file: profileDetails.logo || "",
      phone_no: `91${profileDetails.phone || ""}`,
      email: profileDetails.email || "",
    };
  
    // Create FormData
    const formData = new FormData();
    Object.keys(requestBody).forEach((key) => {
      if (key === "file") {
        const fileData = requestBody.file;
        if (fileData?.buffer) {
          const blob = new Blob([fileData.buffer], { type: fileData.mimetype });
          formData.append("file", blob, fileData.originalname);
        } else if (fileData instanceof File) {
          formData.append("file", fileData);
        }
      } else {
        formData.append(key, requestBody[key]);
      }
    });
  
    try {
      const response = await axiosMain.post("/api/v1/brand-profile", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      console.log("API Response:", response.data);
  
      // Store brand_name in localStorage
      if (requestBody.brand_name) {
        localStorage.setItem("brand_name", requestBody.brand_name);
        setIsModalOpen(false); // Close the modal
      }
  
      handleCloseEditProfileModal();
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  // Function to check if brand_name exists in localStorage
  const shouldOpenModal = () => {
    return !localStorage.getItem("brand_name"); // Returns true if brand_name is not set
  };

  const handleFileSelect = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
   
      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;
        const buffer = new Uint8Array(arrayBuffer); // Convert to Uint8Array
   
        const fileData = {
          fieldname: "logo",
          originalname: selectedFile.name,
          encoding: "7bit",
          mimetype: selectedFile.type,
          buffer: buffer,
          size: selectedFile.size,
        };
   
        // Generate a Data URL for preview
        const previewReader = new FileReader();
        previewReader.onload = (e) => {
          // Update profileDetails
          setProfileDetails((prev) => ({
            ...prev,
            logo: fileData,
            logoPreview: e.target.result,
          }));
   
          // Update userData for Navbar using GlobalContext
          setUserData((prev) => ({
            ...prev,
            user_photo: e.target.result, // Assuming user_photo is for navbar display
          }));
        };
   
        previewReader.readAsDataURL(selectedFile);
      };
   
      reader.readAsArrayBuffer(selectedFile); // Read as ArrayBuffer
    }
  };

  // const handleFileSelect = async (e) => {
  //   const selectedFile = e.target.files[0];
  //   if (selectedFile) {
  //     const reader = new FileReader();

  //     reader.onload = async (event) => {
  //       const arrayBuffer = event.target.result;
  //       const buffer = new Uint8Array(arrayBuffer); // Convert ArrayBuffer to Uint8Array

  //       const fileData = {
  //         fieldname: "logo",
  //         originalname: selectedFile.name,
  //         encoding: "7bit",
  //         mimetype: selectedFile.type,
  //         buffer: buffer, // Uint8Array for backend
  //         size: selectedFile.size,
  //       };

  //       // Generate a Data URL for image preview
  //       const previewReader = new FileReader();
  //       previewReader.onload = (e) => {
  //         setProfileDetails({
  //           ...profileDetails,
  //           logo: fileData,
  //           logoPreview: e.target.result,
  //         });
  //       };
  //       previewReader.readAsDataURL(selectedFile);
  //     };

  //     reader.readAsArrayBuffer(selectedFile); // Read file as ArrayBuffer
  //   }
  // };

  return (
    <>
      {/* Brand-Home Page Content */}
      {isModalOpen && isrefreshModalOpen && (
        <>
          <div className="modal-blur-overlay"></div>

          <Modal
            className="ModalBox"
            show={showEditProfileModal}
            onHide={handleCloseEditProfileModal}
            size="sm" // Small modal
            backdrop="static" // Prevent closing when clicking outside
            keyboard={false} // Prevent closing with Escape key
            centered
          >
            <Modal.Body>
              {/* Close Button */}
              <button
                type="button"
                className="btn-close"
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "15px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
                onClick={handleCloseEditProfileModal}
              >
                ✖
              </button>
              <div className="TitleTag">Let’s setup your Profile!</div>

              <Form>
                {step1 ? (
                  <>
                    <div
                      style={{
                        maxHeight: "500px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#888 #f1f1f1",
                      }}
                    >
                      {/* Logo Upload Section */}
                      <Form.Group controlId="formLogo" className="text-center">
                        <div className="d-flex flex-column align-items-center position-relative">
                          {/* Hidden File Input */}
                          <input
                            type="file"
                            accept="image/*"
                            id="fileInput"
                            onChange={handleFileSelect}
                            className="d-none drop"
                          />

                          {/* Clickable Image/Placeholder with Position Relative */}
                          <div
                            className="position-relative"
                            style={{ width: "110px", height: "110px" }}
                          >
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center w-100 h-100"
                              style={{
                                backgroundColor: profileDetails.logo
                                  ? "transparent"
                                  : "#f0f0f0",
                                cursor: "pointer",
                                overflow: "hidden",
                              }}
                              onClick={() =>
                                document.getElementById("fileInput").click()
                              } // Click on file input
                            >
                              {profileDetails.logoPreview ? (
                                <img
                                  src={profileDetails.logoPreview}
                                  alt="Logo Preview"
                                  className="rounded-circle w-100 h-100"
                                  style={{ objectFit: "cover" }}
                                />
                              ) : (
                                <span>No Image</span>
                              )}
                            </div>

                            {/* Edit Button (Positioned at Bottom-Right of Image) */}
                            {profileDetails.logo && (
                              <div
                                className="position-absolute"
                                style={{ bottom: "-5px", right: "-5px" }}
                              >
                                <Dropdown
                                  show={showEditOptions}
                                  onToggle={(isOpen) =>
                                    setShowEditOptions(isOpen)
                                  }
                                >
                                  {/* Edit Icon as Custom Trigger */}
                                  <div
                                    onClick={() =>
                                      setShowEditOptions(!showEditOptions)
                                    }
                                    style={{
                                      backgroundColor: "#6B8E76",
                                      width: "25px",
                                      height: "25px",
                                      borderRadius: "50%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: "pointer",
                                      boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                      border: "2px solid white",
                                    }}
                                  >
                                    <FaEdit color="white" size={16} />
                                  </div>

                                  {/* Dropdown Menu */}
                                  <Dropdown.Menu align="end">
                                    <Dropdown.Item
                                      onClick={() => {
                                        document
                                          .getElementById("fileInput")
                                          .click();
                                        setShowEditOptions(false);
                                      }}
                                    >
                                      Edit Profile Picture
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        setProfileDetails((prevState) => ({
                                          ...prevState,
                                          logo: null,
                                        }));
                                        setShowEditOptions(false);
                                      }}
                                    >
                                      Remove Profile Picture
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            )}
                          </div>
                        </div>
                      </Form.Group>

                      {/* Two-Column Layout */}

                      <div className="row">
                        {/* Brand Name */}
                        <div className="col-md-6">
                          <Form.Group controlId="formName">
                            <Form.Label>Your Brand's Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={profileDetails.name}
                              onChange={(e) =>
                                setProfileDetails({
                                  ...profileDetails,
                                  name: e.target.value,
                                })
                              }
                            />
                          </Form.Group>
                        </div>

                        {/* Phone Number */}
                        <div className="col-md-6">
                          <Form.Group controlId="formPhone">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                              type="text"
                              value={profileDetails.phone}
                              onChange={(e) =>
                                setProfileDetails({
                                  ...profileDetails,
                                  phone: e.target.value,
                                })
                              }
                            />
                          </Form.Group>
                        </div>

                        {/* Email ID */}
                        <div className="col-md-6">
                          <Form.Group controlId="formEmail">
                            <Form.Label>Email ID</Form.Label>
                            <Form.Control
                              type="email"
                              value={profileDetails.email || userEmail}
                              readOnly
                              onChange={(e) =>
                                setProfileDetails({
                                  ...profileDetails,
                                  email: e.target.value,
                                })
                              }
                            />
                          </Form.Group>
                        </div>

                        {/* Brand Category Dropdown */}
                        <div className="col-md-6">
                          <Form.Group controlId="formCategory">
                            <Form.Label>
                              Select Your Brand's Category
                            </Form.Label>
                            <Dropdown
                              show={openDropdown === "category"}
                              onToggle={(isOpen) =>
                                setOpenDropdown(isOpen ? "category" : null)
                              }
                              className="w-100"
                            >
                              <Dropdown.Toggle
                                variant="light"
                                className="w-100 drop text-start"
                              >
                                {selectedCategories?.length > 0
                                  ? selectedCategories.join(", ")
                                  : "Select Categories"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="w-100 p-2 categories-brand">
                                {categories.map((category, index) => (
                                  <div key={index} className="dropdown-item">
                                    <Form.Check
                                      type="checkbox"
                                      label={category}
                                      checked={selectedCategories.includes(
                                        category
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          category,
                                          "category"
                                        )
                                      }
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  </div>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Form.Group>
                        </div>

                        {/* State Dropdown */}
                        <div className="col-md-6">
                          <Form.Group controlId="formState">
                            <Form.Label>State</Form.Label>
                            <Dropdown
                              show={openDropdown === "state"}
                              onToggle={(isOpen) =>
                                setOpenDropdown(isOpen ? "state" : null)
                              }
                              className="w-100"
                            >
                              <Dropdown.Toggle
                                variant="light"
                                className="w-100 drop text-start"
                              >
                                {selectedStates?.length > 0
                                  ? selectedStates[0]
                                  : "Select State"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="w-100 p-2">
                                {states.map((state, index) => (
                                  <Dropdown.Item
                                    key={index}
                                    onClick={() => setSelectedStates([state])} // Allow only one state selection
                                  >
                                    {state}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Form.Group>
                        </div>

                        {/* City Dropdown */}
                        <div className="col-md-6">
                          <Form.Group controlId="formCity">
                            <Form.Label>City</Form.Label>
                            <Dropdown
                              show={openDropdown === "city"}
                              onToggle={(isOpen) =>
                                setOpenDropdown(isOpen ? "city" : null)
                              }
                              className="w-100"
                            >
                              <Dropdown.Toggle
                                variant="light"
                                className="w-100 drop text-start"
                              >
                                {selectedCity || "Select City"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="w-100 p-2">
                                {cities.map((city, index) => (
                                  <Dropdown.Item
                                    key={index}
                                    onClick={() => setSelectedCity(city)}
                                  >
                                    {city}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Form.Group>
                        </div>

                        {/* Address */}
                        <div className="col-md-6">
                          <Form.Group controlId="formAddress">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                              type="text"
                              value={profileDetails.address}
                              onChange={(e) =>
                                setProfileDetails({
                                  ...profileDetails,
                                  address: e.target.value,
                                })
                              }
                            />
                          </Form.Group>
                        </div>

                        {/* PIN Code */}
                        <div className="col-md-6">
                          <Form.Group controlId="formPin">
                            <Form.Label>PIN Code</Form.Label>
                            <Form.Control
                              type="text"
                              value={profileDetails.pin}
                              onChange={(e) =>
                                setProfileDetails({
                                  ...profileDetails,
                                  pin: e.target.value,
                                })
                              }
                            />
                          </Form.Group>
                        </div>
                      </div>
                      {/* Brand Bio (Full Width) */}
                      <div className="col-md-12 mt-3">
                        <Form.Group controlId="formBio">
                          <Form.Label>Brand’s Bio</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={profileSetupDetails.bio}
                            onChange={(e) =>
                              setProfileSetupDetails({
                                ...profileSetupDetails,
                                bio: e.target.value,
                              })
                            }
                            placeholder="Tell us about your brand..."
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <Form.Group controlId="formWebsite">
                      <Form.Label>Your Brand’s Website (Optional)</Form.Label>
                      <Form.Control
                        type="text"
                        value={profileSetupDetails.website}
                        onChange={(e) =>
                          setProfileSetupDetails({
                            ...profileSetupDetails,
                            website: e.target.value,
                          })
                        }
                      />
                    </Form.Group>

                    <Form.Label>Brand’s Social Media Links</Form.Label>
                    {profileSetupDetails.socialLinks.map((link, index) => (
                      <Form.Group
                        key={index}
                        controlId={`formSocialLink${index}`}
                        className="position-relative"
                      >
                        {/* <Form.Label>{link.platform}</Form.Label> */}
                        <div className="row align-items-center">
                          {/* Instagram Field */}
                          <div className="col-md-4">
                            <Form.Group controlId="formInstagram">
                              <div className="d-flex align-items-center border rounded p-2 bg-white">
                                <img
                                  src={instagram}
                                  alt="Instagram"
                                  className="me-2"
                                  width="24"
                                  height="24"
                                />
                                <Form.Control
                                  type="text"
                                  placeholder="Instagram"
                                  className="border-0 shadow-none"
                                />
                              </div>
                            </Form.Group>
                          </div>

                          {/* YouTube Field */}
                          <div className="col-md-4">
                            <Form.Group controlId="formYouTube">
                              <div className="d-flex align-items-center border rounded p-2 bg-white">
                                <img
                                  src={youtube}
                                  alt="YouTube"
                                  className="me-2"
                                  width="24"
                                  height="24"
                                />
                                <Form.Control
                                  type="text"
                                  placeholder="YouTube"
                                  className="border-0 shadow-none"
                                />
                              </div>
                            </Form.Group>
                          </div>

                          {/* Facebook Field */}
                          <div className="col-md-4">
                            <Form.Group controlId="formFacebook">
                              <div className="d-flex align-items-center border rounded p-2 bg-white">
                                <img
                                  src={facebook}
                                  alt="Facebook"
                                  className="me-2"
                                  width="24"
                                  height="24"
                                />
                                <Form.Control
                                  type="text"
                                  placeholder="Facebook"
                                  className="border-0 shadow-none"
                                />
                              </div>
                            </Form.Group>
                          </div>

                          {/* LinkedIn Field */}
                          <div className="col-md-4 mt-3">
                            <Form.Group controlId="formLinkedIn">
                              <div className="d-flex align-items-center border rounded p-2 bg-white">
                                <img
                                  src={LinkedIn}
                                  alt="LinkedIn"
                                  className="me-2"
                                  width="24"
                                  height="24"
                                />
                                <Form.Control
                                  type="text"
                                  placeholder="LinkedIn"
                                  className="border-0 shadow-none"
                                />
                              </div>
                            </Form.Group>
                          </div>
                          <div className="d-flex flex-column align-items-center col-md-2 mt-3">
                            <button
                              type="button"
                              className="border-0 bg-transparent"
                            >
                              <FaPlus
                                style={{
                                  color: "#6B8E76",
                                  height: "24px",
                                  width: "22px",
                                }}
                              />
                            </button>
                            <span
                              style={{ color: "#00000085", fontSize: "14px" }}
                            >
                              Add More Links
                            </span>
                          </div>
                        </div>
                      </Form.Group>
                    ))}
                  </>
                )}

                <div className="d-flex justify-content-between mt-4 mb-3">
                  <button
                    type="button"
                    className="btn profile-clear-btn"
                    onClick={resetAllFields}
                  >
                    Clear All
                  </button>
                  <div>
                    <button
                      type="button"
                      className="profile btn btn-outline-success mx-2"
                      onClick={handleSave}
                    >
                      Save
                    </button>

                    <button
                      type="button"
                      className=" profile btn btn-success"
                      onClick={handleNext}
                    >
                      {step1 ? "Next" : "Previous"}
                    </button>
                  </div>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </>
      )}

      <div>
        <div className="d-flex justify-content-between align-items-center">

          {CURRENT_USER_ROLE === "admin" ? (
            <div style={{ display: 'flex', gap: '20px' }}>
              <h5
                className="Title"
                style={{ cursor: 'pointer', paddingRight: '20px', fontSize: '30px' }}
                onClick={() => navigate('/brand-home')}
              >
                Influencers
              </h5>

              <h5
                className="Title"
                style={{ cursor: 'pointer', paddingRight: '20px', fontSize: '30px' }}
                onClick={() => navigate('/influencer-home')}
              >
                Brand
              </h5>
            </div>
          )
            :
            (<h2 className="Title">Influencers ({influencers?.length})</h2>)

          }

          <div className="SearchFilterSection">
            <div className="SearchInput">
              <img src={Search} className="img-fluid" alt="Search Icon" />
              <input
                type="text"
                className="form-control"
                placeholder="Search for Influencer, Genre"
                value={searchTerm}
                onChange={(e) => handleSearch(e)}
                autoFocus
              />
            </div>

            {CURRENT_USER_ROLE === "admin" ? (
              <></>
            ) : (<>
              <button onClick={() => favoritesSort()}>
                Favorites{" "}
                <img src={HeartDark} className="img-fluid" alt="Heart Icon" />
              </button>
            </>)}

            <button onClick={toggleFilterPopup}>
              Filters{" "}
              <img src={Filter} className="img-fluid" alt="Filter Icon" />
            </button>
          </div>
        </div>
        <div className="row g-0">
          <div className="TableBox">
            <div className="InfluancerCardView Shorting influencer-list">
              <div className="influencer-card justify-content-end">
                {grideView ? (
                  <div className="Likes">
                    <img
                      src={grideView ? tableicon : View}
                      alt="img"
                      className="img-fluid"
                      onClick={() => toggleView()}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            {grideView ? (
              <>
              <ToastContainer />
              <InfluencerGridList
                influencers={influencers}
                favorites={favorites} // Pass favorites as a prop
                toggleFavorite={toggleFavorite} // Pass toggleFavorite function as a prop
              />
              </>
            ) : (
              <div className="TableBox">
                <div className="InfluancerCardView Shorting influencer-list">
                  {/* kanj */}
                  {CURRENT_USER_ROLE === "admin" ?
                    (<div className="influencer-card">
                      <div
                        className="InfluencerProfile"
                        style={{ marginLeft: "-15px" }}
                      >
                        Influencers({influencers?.length})
                      </div>
                      <div
                        className="InfluencerGenre"
                        style={{ marginLeft: "-68px", paddingLeft: "116px" }}
                      >
                        Genre
                      </div>
                      <div
                        className="InfluencerGenre"
                        style={{ marginLeft: "-120px", paddingLeft: "184px" }}
                      >
                        Email
                      </div>
                      {/* <div className="InfluencerGenre">Cpp</div> */}

                      <div
                        className="engagement"
                        // onClick={() => handleSortEngagement()}
                        style={{ marginLeft: "56px", paddingLeft: "11px" }}
                      >
                        Contact No
                      </div>

                      <div
                        className="InfluencerFollowes"
                        // onClick={handleSortFollowers}
                        style={{ marginLeft: "-91px", paddingLeft: "84px" }}
                      >
                        State
                      </div>

                      <div
                        className="InfluencerEngagement"
                        style={{ marginRight: "66px" }}
                      >
                        Last Login Date
                      </div>

                    </div>)
                    :
                    (<div className="influencer-card">
                      <div
                        className="InfluencerProfile"
                        style={{ marginLeft: "-15px" }}
                      >
                        Influencers({influencers?.length})
                      </div>
                      <div
                        className="InfluencerGenre"
                        style={{ marginLeft: "-68px", paddingLeft: "116px" }}
                      >
                        Genre
                      </div>
                      <div
                        className="InfluencerGenre"
                        style={{ marginLeft: "-120px", paddingLeft: "184px" }}
                      >
                        Reach
                      </div>
                      {/* <div className="InfluencerGenre">Cpp</div> */}

                      <div
                        className="engagement"
                        onClick={() => handleSortEngagement()}
                        style={{ marginLeft: "56px", paddingLeft: "11px" }}
                      >
                        Engagement %{" "}
                        <img
                          src={
                            sortDirectionEngagement === "asc" ? Sort : SortDown
                          }
                          className="img-fluid Sort"
                          alt="Sort Icon"
                        />
                      </div>

                      <div
                        className="InfluencerFollowes"
                        onClick={handleSortFollowers}
                        style={{ marginLeft: "-91px", paddingLeft: "84px" }}
                      >
                        Followers{" "}
                        <img
                          src={sortDirectionFollowers === "asc" ? Sort : SortDown}
                          className="img-fluid Sort"
                          alt="Sort Icon"
                        />
                      </div>

                      <div
                        className="InfluencerEngagement"
                        style={{ marginRight: "66px" }}
                      >
                        Audience Gender
                      </div>
                      <div className="Likes">
                        <img
                          src={grideView ? tableicon : View}
                          alt="img"
                          className="img-fluid"
                          onClick={() => toggleView()}
                        />
                      </div>
                    </div>)
                  }
                  {/* kanj */}
                </div>


                {CURRENT_USER_ROLE == "admin" ?
                  (
                    <div className="InfluancerCardView">
                      <div
                        className="influencer-list"
                        onClick={() => navigate("/influencerstats")}
                      >
                        {influencers.map((influencer) => (
                          <div
                            key={influencer.influencer_id}
                            className="influencer-card"
                          >
                            <div
                              className="InfluencerProfile"
                              style={{ marginLeft: "-22px" }}
                            >
                              <img
                                // src={
                                //   influencer.influencer_profile_url ||
                                //   "path/to/placeholder-image.png"
                                // }
                                src={ProfileImg}
                                className="img-fluid"
                                alt={influencer.influencer_name}
                              />
                              <h4>{influencer.influencer_name}</h4>
                            </div>
                            <div
                              className="InfluencerGenre"
                              style={{ marginLeft: "-21px", paddingRight: "38px" }}
                            >
                              {influencer.genre}
                            </div>
                            <div
                              className="InfluencerGenre"
                              style={{ marginLeft: "-68px", paddingRight: "70px" }}
                            >
                              {influencer.email}
                            </div>
                            <div
                              className="engagement"
                              style={{ marginLeft: "-36px", paddingRight: "240px" }}
                            >
                              <span>{influencer.contact}</span>
                            </div>

                            <div
                              className="InfluencerFollowes"
                              style={{ marginLeft: "-276px", paddingLeft: "138px" }}
                            >
                              {influencer.state}
                            </div>

                            <div
                              className="InfluencerFollowes"
                              style={{ marginLeft: "-276px", paddingLeft: "138px" }}
                            >
                              {influencer.date}
                            </div>


                          </div>
                        ))}
                      </div>
                    </div>
                  )
                  :

                  (
                    <div className="InfluancerCardView">
                      <div
                        className="influencer-list"
                        onClick={() => navigate("/influencerstats")}
                      >
                        {influencers.map((influencer) => (
                          <div
                            key={influencer.influencer_id}
                            className="influencer-card"
                          >
                            <div
                              className="InfluencerProfile"
                              style={{ marginLeft: "-22px" }}
                            >
                              <img
                                // src={
                                //   influencer.influencer_profile_url ||
                                //   "path/to/placeholder-image.png"
                                // }
                                src={ProfileImg}
                                className="img-fluid"
                                alt={influencer.influencer_name}
                              />
                              <h4>{influencer.influencer_name}</h4>
                            </div>
                            <div
                              className="InfluencerGenre"
                              style={{ marginLeft: "-21px", paddingRight: "38px" }}
                            >
                              {influencer.genre}
                            </div>
                            <div
                              className="InfluencerGenre"
                              style={{ marginLeft: "-68px", paddingRight: "70px" }}
                            >
                              {formatFollowers(influencer.reach)}
                            </div>
                            <div
                              className="engagement"
                              style={{ marginLeft: "-36px", paddingRight: "240px" }}
                            >
                              <span>{influencer.engagement}</span>
                            </div>

                            <div
                              className="InfluencerFollowes"
                              style={{ marginLeft: "-276px", paddingLeft: "138px" }}
                            >
                              <span className="audience-icon">
                                <img
                                  src={users}
                                  alt="users"
                                  className="img-fluid"
                                />
                              </span>
                              {formatFollowers(influencer?.followers)}
                            </div>

                            <div
                              className="InfluencerEngagement"
                              style={{ marginRight: "-28px" }}
                            >
                              <p>Male: {influencer.male}</p>
                              <p>Female: {influencer.female}</p>
                              <p>Others: {influencer.other}</p>
                            </div>
                            <div className="Likes">
                              <img
                                src={
                                  favorites.has(influencer.influencer_id)
                                    ? HeartDark
                                    : Heart
                                }
                                alt="Favorite Icon"
                                className="img-fluid"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevents navigation when clicking the heart
                                  toggleFavorite(influencer.influencer_id);
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>)}

              </div>
            )}
          </div>
        </div >
        {isFilterPopupOpen && (
          <div className="filter-popup">
            <div className="filter-popup-content">
              <div className="FilterHeader">
                <li className="active">
                  <h6>Filter</h6>
                </li>
                <div className="clear-btn" onClick={() => resetFilters()}>
                  <span>Clear all</span>
                </div>
                <i
                  className="fa fa-times"
                  onClick={() => setIsFilterPopupOpen(false)}
                ></i>
              </div>

              <div className="Filters">
                <ul className="nav nav-pills">
                  {Object.keys(filterOptions).map((key) => (
                    <li
                      key={key}
                      className={selectedTab === key ? "active" : ""}
                    >
                      <a onClick={() => handleTabChange(key)}>
                        {filterOptions[key].label}
                      </a>
                    </li>
                  ))}
                </ul>

                <div className="filter-options">
                  {selectedTab && (
                    <>
                      {filterOptions[selectedTab].options.map((option) => (
                        <div className="form-check" key={option.value}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`${selectedTab}-${option.value}`}
                            checked={
                              selectedFilters[selectedTab]?.has(option.value) ||
                              false
                            } // Ensures checkbox updates correctly
                            onChange={() =>
                              handleFilterChange(selectedTab, option.value)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${selectedTab}-${option.value}`}
                          >
                            {option.label}
                          </label>
                        </div>
                      ))}
                    </>
                  )}

                  <div className="BtnsGrp">
                    <span>{influencers?.length} Influencers</span>
                    <button
                      type="button"
                      className="btn btn-apply"
                      onClick={() => applyFilters()}
                      style={{ backgroundColor: "#6b8e76", color: "white" }}
                    >
                      Apply Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
        }
      </div >
    </>
  );
}

export default BrandHome;
